import { render } from "./Toggles.vue?vue&type=template&id=2f7f1340&scoped=true"
import script from "./Toggles.vue?vue&type=script&lang=js"
export * from "./Toggles.vue?vue&type=script&lang=js"

import "./Toggles.vue?vue&type=style&index=0&id=2f7f1340&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7f1340"]])

export default __exports__